// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Slidar } from '../AdminDashbord/Slidar';
// import './AdminSlider.css'; // create and import this for styling

// const AdminUploadSlider = () => {
//   const [image, setImage] = useState(null);
//   const [text, setText] = useState("");
//   const [sliders, setSliders] = useState([]);
//   const [uploading, setUploading] = useState(false);

//   // Fetch existing sliders
//   const fetchSliders = async () => {
//     try {
//       const res = await axios.get("/api/sliders");
//       setSliders(res.data);
//     } catch (error) {
//       console.error("Failed to fetch sliders", error);
//     }
//   };

//   useEffect(() => {
//     fetchSliders();
//   }, []);

//   // Upload new slider
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (uploading) return;
//     setUploading(true);
//     const formData = new FormData();
//     formData.append("image", image);
//     formData.append("text", text);

//     try {
//       await axios.post("/api/sliders", formData);
//       alert("Slider uploaded!");
//       setText("");
//       setImage(null);
//       fetchSliders(); // Refresh list
//     } catch (error) {
//       alert("Upload failed");
//       console.error(error);
//     } finally {
//       setUploading(false);
//     }
//   };

//   // Delete slider
//   const handleDelete = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this slider?")) return;
//     try {
//       await axios.delete(`/api/sliders/${id}`);
//       alert("Slider deleted!");
//       fetchSliders(); // Refresh list
//     } catch (error) {
//       alert("Delete failed");
//       console.error(error);
//     }
//   };

//   return (
//    <div className="admin-page-container">
  
//     <Slidar />
  

//   <div className="admin-main-content">
//  <form onSubmit={handleSubmit} className="upload-form">
//   <div className="input-group">
//     <input 
//       type="file" 
//       onChange={(e) => setImage(e.target.files[0])} 
//       required 
//     />
//     <input
//       type="text"
//       placeholder="Enter slider text"
//       value={text}
//       onChange={(e) => setText(e.target.value)}
//       required
//     />
//   </div>

//   <button type="submit" disabled={uploading}>{uploading ? "Uploading..." : "Upload"}</button>
// </form>





//     <h2>Uploaded Sliders</h2>
//     <ul className="slider-list">
//   {sliders.map((slide) => (
//     <li key={slide._id}>
//       <img src={`${slide.imageUrl}`} alt="slide" />
//       <p>{slide.text}</p>
//       <button className="delete" onClick={() => handleDelete(slide._id)}>Delete</button>
//     </li>
//   ))}
// </ul>

//   </div>
// </div>

//   );
// };

// export default AdminUploadSlider;


// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { Slidar } from "../AdminDashbord/Slidar";
// import "./AdminSlider.css";

// const AdminUploadSlider = () => {
//   const [backgroundImage, setBackgroundImage] = useState(null);
//   const [overlayImage, setOverlayImage] = useState(null);
//   const [tag, setTag] = useState("");
//   const [text, setText] = useState("");
//   const [sliders, setSliders] = useState([]);
//   const [uploading, setUploading] = useState(false);

//   // Fetch sliders
//   const fetchSliders = async () => {
//     try {
//       const res = await axios.get("/api/sliders");
//       setSliders(res.data);
//     } catch (error) {
//       console.error("Failed to fetch sliders", error);
//     }
//   };

//   useEffect(() => {
//     fetchSliders();
//   }, []);

//   // Upload new slider
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (uploading) return;
//     setUploading(true);

//     const formData = new FormData();
//     formData.append("image", backgroundImage);
//     if (overlayImage) {
//       formData.append("overlayImage", overlayImage);
//     }
//     formData.append("tag", tag);
//     formData.append("text", text);

//     try {
//       await axios.post("/api/sliders", formData);
//       alert("Slider uploaded!");
//       setTag("");
//       setText("");
//       setBackgroundImage(null);
//       setOverlayImage(null);
//       fetchSliders();
//     } catch (error) {
//       alert("Upload failed");
//       console.error(error);
//     } finally {
//       setUploading(false);
//     }
//   };

//   // Delete slider
//   const handleDelete = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this slider?")) return;
//     try {
//       await axios.delete(`/api/sliders/${id}`);
//       alert("Slider deleted!");
//       fetchSliders();
//     } catch (error) {
//       alert("Delete failed");
//       console.error(error);
//     }
//   };

//   return (
//     <div className="admin-page-container">
//       <Slidar />

//       <div className="admin-main-content">
//         <form onSubmit={handleSubmit} className="upload-form">
//           <div className="input-group">
//             {/* Background Image */}
//             <label><b>Background Image *</b></label>
//             <input
//               type="file"
//               accept="image/*"
//               onChange={(e) => setBackgroundImage(e.target.files[0])}
//               required
//             />

//             {/* Overlay Image */}
//             <label><b>Overlay Image (Optional)</b></label>
//             <input
//               type="file"
//               accept="image/*"
//               onChange={(e) => setOverlayImage(e.target.files[0])}
//             />

//             {/* Tag */}
//             <label><b>Small Tag (above title, optional)</b></label>
//             <input
//               type="text"
//               placeholder="Enter small tag"
//               value={tag}
//               onChange={(e) => setTag(e.target.value)}
//             />

//             {/* Main Text */}
//             <label><b>Slider Title / Text *</b></label>
//             <input
//               type="text"
//               placeholder="Enter main slider text"
//               value={text}
//               onChange={(e) => setText(e.target.value)}
//               required
//             />
//           </div>

//           <button type="submit" disabled={uploading}>
//             {uploading ? "Uploading..." : "Upload"}
//           </button>
//         </form>

//         <h2>Uploaded Sliders</h2>
//         <ul className="slider-list">
//           {sliders.map((slide) => (
//             <li key={slide._id}>
//               <p><b>Background:</b></p>
//               <img
//                 src={`${slide.imageUrl}`}
//                 alt="background"
//                 style={{ maxWidth: "250px", borderRadius: "4px" }}
//               />

//               {slide.overlayImageUrl && (
//                 <>
//                   <p><b>Overlay:</b></p>
//                   <img
//                     src={`${slide.overlayImageUrl}`}
//                     alt="overlay"
//                     style={{ maxWidth: "250px", borderRadius: "4px" }}
//                   />
//                 </>
//               )}

//               {slide.tag && <p><b>Tag:</b> {slide.tag}</p>}
//               {slide.text && <p><b>Text:</b> {slide.text}</p>}

//               <button
//                 className="delete"
//                 onClick={() => handleDelete(slide._id)}
//               >
//                 Delete
//               </button>
//             </li>
//           ))}
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default AdminUploadSlider;



import React, { useEffect, useState } from "react";
import axios from "axios";
import { Slidar } from "../AdminDashbord/Slidar";
import "./AdminSlider.css";

const AdminUploadSlider = () => {
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [overlayImage, setOverlayImage] = useState(null);
  const [tag, setTag] = useState("");
  const [text, setText] = useState("");
  const [sliders, setSliders] = useState([]);
  const [uploading, setUploading] = useState(false);

  // NEW: Track editing state
  const [editingId, setEditingId] = useState(null);

  // Fetch sliders
  const fetchSliders = async () => {
    try {
      const res = await axios.get("/api/sliders");
      setSliders(res.data);
    } catch (error) {
      console.error("Failed to fetch sliders", error);
    }
  };

  useEffect(() => {
    fetchSliders();
  }, []);

  // Upload or Update slider
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (uploading) return;
    setUploading(true);

    const formData = new FormData();
    if (backgroundImage) formData.append("image", backgroundImage);
    if (overlayImage) formData.append("overlayImage", overlayImage);
    formData.append("tag", tag);
    formData.append("text", text);

    try {
      if (editingId) {
        // Update existing slider
        await axios.put(`/api/sliders/${editingId}`, formData);
        alert("Slider updated!");
      } else {
        // Create new slider
        await axios.post("/api/sliders", formData);
        alert("Slider uploaded!");
      }
      resetForm();
      fetchSliders();
    } catch (error) {
      alert("Action failed");
      console.error(error);
    } finally {
      setUploading(false);
    }
  };

  // Delete slider
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this slider?")) return;
    try {
      await axios.delete(`/api/sliders/${id}`);
      alert("Slider deleted!");
      fetchSliders();
    } catch (error) {
      alert("Delete failed");
      console.error(error);
    }
  };

  // Edit slider
  const handleEdit = (slide) => {
    setEditingId(slide._id);
    setTag(slide.tag || "");
    setText(slide.text || "");
    setBackgroundImage(null); // let user re-upload if they want
    setOverlayImage(null);
  };

  // Reset form after upload/update
  const resetForm = () => {
    setEditingId(null);
    setTag("");
    setText("");
    setBackgroundImage(null);
    setOverlayImage(null);
  };

  return (
    <div className="admin-page-container">
      <Slidar />

      <div className="admin-main-content">
        <form onSubmit={handleSubmit} className="upload-form">
          <div className="input-group">
            {/* Background Image */}
            <label><b>Background Image {editingId ? "(leave empty to keep old)" : "*"}</b></label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setBackgroundImage(e.target.files[0])}
              required={!editingId} // required only in upload mode
            />

            {/* Overlay Image */}
            <label><b>Overlay Image (Optional)</b></label>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setOverlayImage(e.target.files[0])}
            />

            {/* Tag */}
            <label><b>Small Tag (above title, optional)</b></label>
            <input
              type="text"
              placeholder="Enter small tag"
              value={tag}
              onChange={(e) => setTag(e.target.value)}
            />

            {/* Main Text */}
            <label><b>Slider Title / Text *</b></label>
            <input
              type="text"
              placeholder="Enter main slider text"
              value={text}
              onChange={(e) => setText(e.target.value)}
              required
            />
          </div>

          <button type="submit" disabled={uploading}>
            {uploading ? "Saving..." : editingId ? "Update" : "Upload"}
          </button>

          {editingId && (
            <button type="button" onClick={resetForm} style={{ marginLeft: "10px" }}>
              Cancel Edit
            </button>
          )}
        </form>

        <h2>Uploaded Sliders</h2>
        <ul className="slider-list">
          {sliders.map((slide) => (
            <li key={slide._id}>
              <p><b>Background:</b></p>
              <img
                src={`${slide.imageUrl}`}
                alt="background"
                style={{ maxWidth: "250px", borderRadius: "4px" }}
              />

              {slide.overlayImageUrl && (
                <>
                  <p><b>Overlay:</b></p>
                  <img
                    src={`${slide.overlayImageUrl}`}
                    alt="overlay"
                    style={{ maxWidth: "250px", borderRadius: "4px" }}
                  />
                </>
              )}

              {slide.tag && <p><b>Tag:</b> {slide.tag}</p>}
              {slide.text && <p><b>Text:</b> {slide.text}</p>}

              <button className="edit" onClick={() => handleEdit(slide)}>
                Edit
              </button>
              <button className="delete" onClick={() => handleDelete(slide._id)}>
                Delete
              </button>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default AdminUploadSlider;
